/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EServices.css';
import pans from './panStyle.scss';
import _ from 'lodash';
import waiting from '../paymentStatus/waiting-wheel-300x300.gif';
import CustomizedMap from './CustomizedMap';
import { POG_SERVICES } from './constants';
import GrayPanel from '../../components/GrayPanel';
import ModalAlert from './ModalAlert';
import fetch from '../../core/fetch';
import { connect } from 'react-redux'
import { PersonalDataContainer, DecisionContainer } from '../../containers';
import agentConfig from './agent';
import RodoContent from '../../components/RodoContent';
import AttachmentsPanel from '../../components/AttachmentsPanel';

import history from '../../core/history';
import u from './utils';
import { countAction, trackEvent } from '../../lib/utils';
import v from './validators';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils'
import { showDraftsCondition, saveDraft, areEqual, getDraft, getDraftDataFromState } from '../../components/DraftManagement/draftManager';
import ButtonsPanel from './utils/ButtonsPanel';

const loadingTitle = 'Obliczanie opłaty...';

const loadingBody =
  (<div style={{ height: '100px' }}>
    <div style={{ textAlign: 'center' }}>
      <img alt="Loader" src={waiting} style={{ width: '150px', height: '150px' }} />
    </div>
    <p style={{ textAlign: 'center' }}>
      Trwa proces obliczania opłaty za dokument. Proszę czekać.
    </p>
  </div>);

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
};

const bodyStyle = {
  textAlign: 'center',
  marginTop: '100px',
  marginBottom: '100px'
}

const InfoTypeDict = {
  adres: {
    label: 'Adres',
    editable: true,
  },
  cel: {
    label: 'Zaświadczenie jest mi niezbędne celem przedłożenia w',
    editable: true,
    type: 'textarea',
  },
};

const InfoTypeDict2 = {
  cel: {
    label: 'Zaświadczenie jest mi niezbędne celem przedłożenia w:',
    editable: true,
    type: 'textarea',
  },
};

const InfoTypeDict3 = {
  miejscowosc: {
    label: 'Miejscowość:',
    editable: true,
  },
  cel: {
    label: 'Cel uzyskania wypisu i wyrysu:',
    editable: true,
    type: 'textarea',
  },
};

const InfoTypeDict4 = {
  cel: {
    label: 'Cel uzyskania wypisu i wyrysu:',
    editable: true,
    type: 'textarea',
  },
};

const InfoTypeDict5 = {
  ulica: {
    label: 'Ulica/Miejscowość',
    editable: true,
  },
  numer: {
    label: 'Numer',
    editable: true,
  },
};

const InfoTypeDict7 = {
  numerDzialki: {
    label: 'Obręb ew. i nr działki',
    editable: true,
    type: 'textarea',
  },
};

const InfoTypeDict8 = {
  adres: {
    label: 'Miejscowość',
    editable: true,
  },
  cel: {
    label: 'Dokument jest mi niezbędny celem przedłożenia w',
    editable: true,
  },
};

const rewitalOptions = [
  {
    label: 'NIE',
    value: 'NIE',
    state: 'rewital',
  },
  {
    label: 'TAK',
    value: 'TAK',
    state: 'rewital',
  },
];

const InfoTypeDict6 = {
  cel: {
    label: 'Zaświadczenie jest mi niezbędne w celu',
    editable: true,
    type: 'textarea',
  },
  rewital: {
    label: 'Proszę o zawarcie w zaświadczeniu informacji, czy ww. działka(i) położona(e) są na obszarze rewitalizacji wyznaczonej na podstawie art. 8 ustawy z dnia 9 października 2015 r. o rewitalizacji.',
    editable: true,
    type: 'Select',
    options: rewitalOptions,
  },
};

const InfoTypeDict9 = {
  cel: {
    label: 'Dokument jest mi niezbędny w celu',
    editable: true,
    type: 'textarea',
  },
  uwagi: {
    label: 'Uwagi',
    editable: true,
    type: 'textarea',
  },
};

const celOptions = [
  {
    label: 'przedłożenia w Kancelarii Notarialnej',
    value: 'przedłożenia w Kancelarii Notarialnej',
    state: 'cel',
  },
  {
    label: 'przełożenia w Urzędzie Skarbowym',
    value: 'przełożenia w Urzędzie Skarbowym',
    state: 'cel',
  },
  {
    label: 'przedłożenia w operacie szacunkowym',
    value: 'przedłożenia w operacie szacunkowym',
    state: 'cel',
  },
  {
    label: 'podziału nieruchomości',
    value: 'podziału nieruchomości',
    state: 'cel',
  },
  {
    label: 'architektonicznych',
    value: 'architektonicznych',
    state: 'cel',
  },
  {
    label: 'na wniosek osoby zainteresowanej',
    value: 'na wniosek osoby zainteresowanej',
    state: 'cel',
  },
];

const InfoTypeDict10 = {
  ulica: {
    label: 'Ulica',
    editable: true,
  },
  cel: {
    label: 'Dokument jest mi niezbędny do celów:',
    editable: true,
    type: 'Select',
    options: celOptions,
  },
};

const celOptions2 = [
  {
    label: 'budowa budynku mieszkalnego',
    value: 'budowa budynku mieszkalnego',
    state: 'cel',
  },
  {
    label: 'inny',
    value: 'inny',
    state: 'cel',
  },
];

const InfoTypeDict11 = {
  cel: {
    label: 'Dokument jest mi niezbędny do celów:',
    editable: true,
    type: 'Select',
    options: celOptions2,
  },
};

const InfoTypeDict12 = {
  adres: {
    label: 'Miejscowość:',
    editable: true,
  },
  cel: {
    label: 'Zaświadczenie jest potrzebne celem przedłożenia:',
    editable: true,
    type: 'textarea',
  },
};

const InfoTypeDict13 = {
  adres: {
    label: 'Miejscowość:',
    editable: true,
  },
};

const servicesWithoutTemplates = [
  'PrzebiegDrogiInfo',
  'ZagospDzialkiInfo',
  'NrIPowDzialkiInfo',
  'WlasnoscDzialkiInfo',
  'ZimoweUtrzymanieDrog',
  'ZabytekInfo',
  'WodneInfo',
  'OdpadyInfo',
  'GESUTInfo',
  'InformacjaSTUDIUM'
];

const servicesWithoutAttachments = [
  ...servicesWithoutTemplates,
  'WypisZMpzp',
  'WypisIWyrysZMpzp'
];

const districtsWithoutAttachments = [
  'gmina_kluczbork',
];

const stateToDraft = [
  "info",
  "selectedParcels",
  "selectedRoads",
  "acceptApplication",
  "signDoc",
  "acceptRODO",
  "differentReason",
  "docReason",
  "attachments",
];

class EServices extends React.Component {

  state = {
    info: {
      miejscowosc: null,
      ulica: null,
      numer: null,
      rodzaj: 'MPZP',
      adres: null,
      cel: null,
      uwagi: null,
      rewital: 'NIE',
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
      numerDzialki: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    setSelectDrogi: false,
    setSelectDzialki: true,
    acceptApplication: false,
    signDoc: false,
    acceptRODO: false,
    showError: false,
    showErrorMpzp: false,
    errors: {},
    errorTitle: '',
    errorText: '',
    docReason: '',
    differentReason: '',
    jobId: null,
    progress: 0,
    mpzpValid: true,
    mpzpValidTitle: '',
    mpzpValidText: '',
    viewPortWidth: null,
    eserviceDistrict: null,
    redirect_to: null,
    attachments: null,
    draftAttachments: null,
    isMounted: false,
    loading: false,
    showDrafts: false,
  };

  validators = {};

  onHide = () => this.setState({ showError: !this.state.showError });
  onHideMpzp = () => this.setState({ showErrorMpzp: !this.state.showErrorMpzp });
  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels })
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads })
  setSelectDrogi = (val, callback = null) => this.setState({ setSelectDrogi: val })
  setSelectDzialki = (val, callback = null) => this.setState({ setSelectDzialki: val })
  changeApplicationState = () => this.setState({ acceptApplication: !this.state.acceptApplication });
  changeSignDoc = () => this.setState({ signDoc: !this.state.signDoc });
  changeAcceptRODO = () => this.setState({ acceptRODO: !this.state.acceptRODO });

  async componentDidMount() {
    // skierniewice
    if (this.props.prefix === 'skierniewice') {
      if (this.props.serviceInfo.eservice.shortName === 'ZgloszenieLatarni') {
        this.setState({ redirect_to: 'http://mapa.inspire-hub.pl/#/skierniewice' });
      }
      else if (this.props.serviceInfo.eservice.shortName === 'WniosekMPZP/Studium' || this.props.serviceInfo.eservice.shortName === 'UwagaMPZP/Studium') {
        this.setState({ redirect_to: 'http://mapa.inspire-hub.pl/partycypacja/skierniewice' });
      }
    }

    const showDrafts = showDraftsCondition(this.props.prefix);
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
          showDrafts: showDrafts,
        }, () => this.updateValidators());
      });

    if (showDrafts) {
      const draftData = await getDraft(this.props.prefix, this.props.serviceInfo.eservice.shortName);

      if (draftData) {
        this.setState({ ...draftData, draftAttachments: draftData.attachments, isMounted: true }, () => {
          window.dispatchEvent(
            new CustomEvent("draft:loaded")
          );
        });
      } else {
        this.setState({ isMounted: true });
      }
    } else {
      this.setState({
        isMounted: true
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showDrafts) {
      if (!this.state.isMounted) return;

      if (!prevState.isMounted && this.state.isMounted) return;

      const prevDraft = getDraftDataFromState(prevState, stateToDraft);
      const currentDraft = getDraftDataFromState(this.state, stateToDraft);

      if (this.props.serviceInfo.user && !areEqual(prevDraft, currentDraft)) {
        saveDraft(
          currentDraft,
          this.props.prefix,
          this.props.serviceInfo.eservice.shortName
        );
      }
    }
  }

  handleManualDraftSave = () => {
    const draft = getDraftDataFromState(this.state, stateToDraft);

    saveDraft(
      draft,
      this.props.prefix,
      this.props.serviceInfo.eservice.shortName,
      { debounce: false } // wymuszony zapis
    );
  };

  updateValidators = () => {
    if (this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP' && this.props.prefix === 'hrubieszow') {
      this.validators = {
        adres: [v.NotNull],
        cel: [v.NotNull],
      };
    }

    if (['WypisIWyrysZMpzp'].includes(this.props.serviceInfo.eservice.shortName) && ['gmina_olesno_powiat_oleski', 'gmina_jedwabno'].includes(this.props.prefix)) {
      this.validators = {
        cel: [v.NotNull],
      };
    }

    if (['WypisIWyrysZMpzp', 'WypisIWyrysZeStudium', 'ZaswiadczenieMPZP' , 'ZaswiadczenieStudium'].includes(this.props.serviceInfo.eservice.shortName) && ['gmina_ulan_majorat'].includes(this.props.prefix)) {
      this.validators = {
        cel: [v.NotNull, v.MaxLength(100)]
      };
    }

    if (['WypisIWyrysZMpzp', 'WypisIWyrysZeStudium'].includes(this.props.serviceInfo.eservice.shortName) && ['gmina_niedzwiada'].includes(this.props.prefix)) {
      this.validators = {
        cel: [v.NotNull]
      };
    }

    if (['ZaswiadczenieMPZP', 'ZaswiadczenieStudium'].includes(this.props.serviceInfo.eservice.shortName) && this.props.prefix === 'gmina_morag') {
      this.validators = {
        cel: [v.NotNull],
        rewital: [v.NotSelected],
      };
    }

    if (this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium' && this.props.prefix === 'hrubieszow') {
      this.validators = {
        cel: [v.NotNull],
      };
    }
    if (this.state.eserviceDistrict && this.state.eserviceDistrict.custom) {
      this.validators = {
        ulica: [v.NotNull],
        numer: [v.NotNull],
      };
    }

    const roadServices = ['PrzebiegDrogiInfo', 'ZimoweUtrzymanieDrog'];

    if (roadServices.includes(this.props.serviceInfo.eservice.shortName)) {
      this.setState({ setSelectDzialki: false, setSelectDrogi: true });
    }

    if (this.props.prefix === 'gmina_bobowa' && (this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium' || this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZeStudium') ) {
      this.validators = {
        numerDzialki: [v.NotNull],
      };
    }
    if (this.props.prefix === 'gmina_ilowo_osada' && ['ZaswiadczenieMPZP', 'WypisIWyrysZMpzp'].includes(this.props.serviceInfo.eservice.shortName)) {
      this.validators = {
        cel: [v.NotNull],
        adres: [v.NotNull],
      };
    }

    if (this.props.prefix === 'gmina_inowlodz' && ['WypisZeStudium', 'WyrysZeStudium', 'WypisZMpzp', 'WyrysZMpzp'].includes(this.props.serviceInfo.eservice.shortName)) {
      this.validators = {
        cel: [v.NotNull],
      };
    }

    if (this.props.prefix === 'gmina_krasnystaw') {
      this.validators = {
        cel: [v.NotSelected]
      };
    }

    if (this.props.prefix === 'mszana_dolna') {
      this.validators = {
        cel: [v.NotSelected]
      };
    }

    if (this.props.prefix === 'gmina_komarow_osada' && ['WypisIWyrysZMpzp'].includes(this.props.serviceInfo.eservice.shortName)) {
      this.validators = {
        miejscowosc: [v.NotNull],
        cel: [v.NotNull],
      };
    }

    if (this.props.prefix === 'gmina_komarow_osada' && ['ZaswiadczenieMPZP'].includes(this.props.serviceInfo.eservice.shortName)) {
      this.validators = {
        cel: [v.NotNull],
      };
    }

    if (this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP' && this.props.prefix === 'gmina_bisztynek') {
      this.validators = {
        adres: [v.NotNull],
        cel: [v.NotNull],
      };
    }

        if (this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZMpzp' && this.props.prefix === 'gmina_bisztynek') {
      this.validators = {
        adres: [v.NotNull],
      };
    }

    if (this.state.eserviceDistrict.enableAgent) {
      this.validators.agentAdd = [v.NotSelected];
    } else {
      this.validators.agentAdd = [];
    }

    if (this.state.info.agentAdd === 'TAK') {
      this.validators.agentName = [v.NotNull];
      this.validators.agentAddress = [v.NotNull];
      this.validators.agentPostOffice = [v.NotNull];
      this.validators.agentPostalCode = [v.NotNull];
      this.validators.agentPhoneNumber = [v.NotNull];
      this.validators.agentMotionAddress = [v.NotNull];
    } else {
      this.validators.agentName = [];
      this.validators.agentAddress = [];
      this.validators.agentPostOffice = [];
      this.validators.agentPostalCode = [];
      this.validators.agentPhoneNumber = [];
      this.validators.agentMotionAddress = [];
    }

  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name, this.updateValidators),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name, this.updateValidators),
    );
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  validateAcceptance = () => {
    if (this.props.isDisabled) {
      this.setState({ errorText: 'Przepraszamy. Usługa jest tymczasowo wyłączona.', errorTitle: 'Tymczasowa niedostępność usługi.', showError: true, loading: false, });
      return false;
    } else if ((this.props.serviceInfo.eservice.confirmText && !this.state.acceptApplication)) {
      this.setState({ errorText: 'Proszę o akceptację wymaganych pól. ', errorTitle: 'Błędnie wypełniony formularz', showError: true, loading: false, });
      return false;
    }
    else if (this.props.prefix === "gmina_biala_rawska" && (this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZMpzp' || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP') && !this.state.acceptRODO) {
      this.setState({ errorText: 'Proszę o akceptację wymaganych pól. ', errorTitle: 'Błędnie wypełniony formularz', showError: true, loading: false, });
      return false;

    } else if (!this.state.mpzpValid) {
      const isPogService = POG_SERVICES.includes(this.props.serviceInfo.eservice.shortName);

      this.setState({
        mpzpValidText: isPogService ? 'Jedna lub więcej działek nie ma pokrycia w planie ogólnym gminy.' : 'Jedna lub więcej działek nie ma pokrycia w MPZP.',
        mpzpValidTitle: 'Błędnie wybrane działki',
        showErrorMpzp: true,
        loading: false,
      });
      return false;
    } else if (this.state.setSelectDzialki && this.state.selectedParcels.length <= 0 && !(this.props.prefix === 'gmina_bobowa' && (this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZeStudium' || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium'))) {
      this.setState({ errorText: 'Wymagane jest wybranie co najmniej jednej działki ewidencyjnej.', errorTitle: 'Błędnie wypełniony formularz.', showError: true, loading: false, });
      return false;
    } else if (this.state.setSelectDrogi && this.state.selectedRoads.length <= 0) {
      this.setState({ errorText: 'Wymagane jest wybranie co najmniej jednej drogi.', errorTitle: 'Błędnie wypełniony formularz.', showError: true, loading: false, });
      return false;
    }
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return false;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return false;
    }
    return true;
  }

  runService = () => {
    if (!this.validateAcceptance()) {
      return;
    }
    const url = `${process.env.API_URL}/eservices/${this.props.district}/service/${this.props.serviceInfo.eservice.shortName}`;
    const data = {
      dzialki: this.state.selectedParcels,
      drogi: this.state.selectedRoads,
      info: this.state.info,
      attachments: this.state.attachments,
      urzad: this.props.districts[this.props.prefix],
    };
    data['shortName'] = this.props.serviceInfo.eservice.shortName;
    if (['ZaswiadczenieMPZP', 'ZaswiadczenieStudium', 'ZaswiadczeniePOG'].includes(this.props.serviceInfo.eservice.shortName)) {
      data['docReason'] = this.state.docReason !== 'inne...' ? this.state.docReason : this.state.differentReason;
    }
    if (this.props.serviceInfo.eservice.requiresUserInfo) {
      data['userID'] = this.props.serviceInfo.user.ID;
      data['userType'] = this.props.serviceInfo.user.userType;
      data['dane_wnioskodawcy'] = `${this.props.serviceInfo.user.FirstName} ${this.props.serviceInfo.user.LastName}<br />
                                  ul. ${this.props.serviceInfo.user.AddressStreet} ${this.props.serviceInfo.user.AddressNumber}/${this.props.serviceInfo.user.AddressFlat}<br />
                                  ${this.props.serviceInfo.user.AddressZipCode} ${this.props.serviceInfo.user.AddressCity}`
    }
    const odp = fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(r => {
        if (r.status === 200) {
          return r.json();
        }
        this.onJobFailed();
      })
      .then(resp => {
        if (this.props.serviceInfo.eservice.returnsDoc) {
          window.location.href = `${process.env.API_URL}/eservices/${this.props.district}/getDoc/${resp.fileName}`;
          countAction(this.props.prefix, 4, 2, this.props.serviceInfo.eservice.id);
        } else {
          this.setState({ jobId: resp.message }, () => this.getJobStatus());
        }
      })
      .catch(err => {
        this.onJobFailed();
      });
  }

  onJobFinish = (resp) => {
    trackEvent({
      category: 'application',
      action: 'click',
      name: this.props.serviceInfo.eservice.title,
    });
    if (this.props.serviceInfo.user.userType === 'local') {
      window.location.href = `/eservices/eserviceSummary/${this.state.jobId}`;
    } else {
      window.location.href = `/eservices/eserviceSummary/${this.state.jobId}?customerId=${this.props.query.customerId}`;
    }
  }

  onJobFailed = () => this.setState({
    errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
    errorTitle: 'Tymczasowa niedostępność usługi.',
    showError: true,
    loading:false,
  });

  getJobStatus = () => fetch(`${process.env.API_URL}/service/status/${this.state.jobId}`, { method: 'GET' })
    .then(r => r.json())
    .then(resp => {
      if (resp.status === 'started' || resp.status === 'queued') {
        setTimeout(this.getJobStatus, 1000);
      }
      if (resp.status === 'finished') {
        this.onJobFinish(resp);
      }
      if (resp.status === 'failed') {
        this.onJobFailed()
      }
    }
    );
  handleRedirect = () => {
    const redirect = '/urzad';
    window.location.href = redirect;
  }

  mpzpValidator = (valid) => {
    if (valid !== this.state.mpzpValid) {
      this.setState({ mpzpValid: valid });
    }
  }

  render() {
    let isMobile = false;
    let isTablet = false;
    if (this.state.isMounted) {
      isMobile = isMobileView(window);
      isTablet = isTabletView(window);
    }
    if (this.state.redirect_to) {
      window.location.replace(this.state.redirect_to);
      return (
        <div className={s.root}>
          <div className={s.container}>
            <div style={{ textAlign: 'center' }}>
              <GrayPanel title="" bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}><img alt="Loader" src={waiting} /></GrayPanel>
            </div>
          </div>
        </div>
      );
    }

    // layout classes
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };

    if (this.state.isMounted) {
      return (
        <div className={s.root}>
          <div className={s.container}>
            <div className="row mobile-row" style={{ marginTop: '15px' }}>
              <h3 style={{ textAlign: 'center' }}>
                {this.props.serviceInfo.eservice.title}
              </h3>
              {this.props.serviceInfo.eservice.requiresUserInfo && this.props.serviceInfo.user ?
                <PersonalDataContainer userData={this.props.serviceInfo.user} />
                : null}
              {this.props.serviceInfo.eservice.enableMap && !(this.props.prefix === 'gmina_bobowa' && (this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZeStudium' || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium')) ?
                <GrayPanel title="Wybierz działki">
                  { renderHelpDesc(isMobile, isTablet) }
                  <CustomizedMap
                    serviceType={this.props.serviceInfo.eservice.shortName}
                    setParcels={this.setParcels}
                    setRoads={this.setRoads}
                    setSelectDzialki={this.setSelectDzialki}
                    setSelectDrogi={this.setSelectDrogi}
                    selectedParcels={this.state.selectedParcels}
                    selectedRoads={this.state.selectedRoads}
                    obreby={this.props.serviceInfo.precints}
                    district={this.props.districts[this.props.prefix]}
                    prefix={this.props.prefix}
                    mapState={this.props.mapstates[0]}
                    settings={this.props.serviceInfo.eservice.mapConfig}
                    mpzpValidator={this.mpzpValidator}
                    dokumentType={this.props.serviceInfo.eservice}
                  />
                  {(this.props.prefix === "gmina_biala_rawska" && (this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZMpzp' || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP')) ?
                    <div className="help-desc">
                      <div className={s.subtitle}>
                        <input
                          name="isDefault"
                          type="checkbox"
                          value={this.state.acceptRODO}
                          onChange={this.changeAcceptRODO}
                        /> <gwiazda style={{ color: 'red' }}>*</gwiazda>Zgoda na przetwarzanie danych
                        <u.RODOBialaRawska />
                      </div>
                      <div className={s.subtitle} style={{ color: 'red' }}>
                        * - Pole obowiązkowe
                    </div></div>
                    : null}
                </GrayPanel> : null
              }
              {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
                <DecisionContainer
                  title={'Pełnomocnik'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={agentConfig.agentInfoDict}
                  onChange={e => this.onChange(e, 'info')}
                  onChangeSelect={e => this.onChangeSelect(e, 'info')}
                >
                  <br />
                  <p style={{ fontWeight: 'bold' }}>
                  W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
                  </p>
                </DecisionContainer> : null }
              {this.state.info.agentAdd === 'TAK' ?
                <DecisionContainer
                  title={'Dane identyfikacyjne pełnomocnika'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={agentConfig.agentDict}
                  onChange={e => this.onChange(e, 'info')}
                /> : null }
              {this.state.eserviceDistrict && this.state.eserviceDistrict.custom ?
                <DecisionContainer
                  title={'Dane o działce'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict5}
                  onChange={e => this.onChange(e, 'info')}
                /> : null }
                {this.props.prefix === 'gmina_bobowa' && (this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZeStudium' || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium') ?
                <DecisionContainer
                  title={'Dane o działce'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict7}
                  onChange={e => this.onChange(e, 'info')}
                /> : null }
              {((this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP')
                && this.props.prefix === 'hrubieszow') ?
                  <DecisionContainer
                    title={'Dodatkowe informacje'}
                    data={this.state.info}
                    errors={this.state.errors}
                    formDict={InfoTypeDict}
                    onChange={e => this.onChange(e, 'info')}
                  /> : null
              }
              {((this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium')
                && this.props.prefix === 'hrubieszow') ?
                  <DecisionContainer
                    title={'Dodatkowe informacje'}
                    data={this.state.info}
                    errors={this.state.errors}
                    formDict={InfoTypeDict2}
                    onChange={e => this.onChange(e, 'info')}
                  /> : null
              }
              {((['WypisIWyrysZMpzp'].includes(this.props.serviceInfo.eservice.shortName) && ['gmina_olesno_powiat_oleski', 'gmina_jedwabno'].includes(this.props.prefix))
                || (['WypisIWyrysZMpzp', 'WypisIWyrysZeStudium'].includes(this.props.serviceInfo.eservice.shortName) && ['gmina_ulan_majorat', 'gmina_niedzwiada'].includes(this.props.prefix))) ?
                  <DecisionContainer
                    title={'Dodatkowe informacje'}
                    data={this.state.info}
                    errors={this.state.errors}
                    formDict={InfoTypeDict4}
                    onChange={e => this.onChange(e, 'info')}
                  /> : null
              }
              {['ZaswiadczenieMPZP', 'ZaswiadczenieStudium'].includes(this.props.serviceInfo.eservice.shortName) && ['gmina_ulan_majorat'].includes(this.props.prefix) ? 
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict2}
                  onChange={e => this.onChange(e, 'info')}
                />
              : null}
              {((this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP'
              || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium')
                && this.props.prefix === 'gmina_morag') ?
                  <DecisionContainer
                    title={'Dodatkowe informacje'}
                    data={this.state.info}
                    errors={this.state.errors}
                    formDict={InfoTypeDict6}
                    onChange={e => this.onChange(e, 'info')}
                    onChangeSelect={e => this.onChangeSelect(e, 'info')}
                  /> : null
              }
              {((this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP'
              || this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZMpzp')
                && this.props.prefix === 'gmina_ilowo_osada') ?
                  <DecisionContainer
                    title={'Dodatkowe informacje'}
                    data={this.state.info}
                    errors={this.state.errors}
                    formDict={InfoTypeDict8}
                    onChange={e => this.onChange(e, 'info')}
                    onChangeSelect={e => this.onChangeSelect(e, 'info')}
                  /> : null
              }

              {this.props.prefix === 'gmina_inowlodz' && ['WypisZeStudium', 'WyrysZeStudium', 'WypisZMpzp', 'WyrysZMpzp'].includes(this.props.serviceInfo.eservice.shortName) ?
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict9}
                  onChange={e => this.onChange(e, 'info')}
                  onChangeSelect={e => this.onChangeSelect(e, 'info')}
                /> 
              : null}
              {this.props.prefix === 'mszana_dolna' ?
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict10}
                  onChange={e => this.onChange(e, 'info')}
                  onChangeSelect={e => this.onChangeSelect(e, 'info')}
                /> 
              : null}

              {this.props.prefix === 'gmina_krasnystaw' ?
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict11}
                  onChange={e => this.onChange(e, 'info')}
                  onChangeSelect={e => this.onChangeSelect(e, 'info')}
                /> 
              : null}

              {this.props.prefix === 'gmina_bisztynek' && ['ZaswiadczenieMPZP'].includes(this.props.serviceInfo.eservice.shortName) ?
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict12}
                  onChange={e => this.onChange(e, 'info')}
                  onChangeSelect={e => this.onChangeSelect(e, 'info')}
                /> 
              : null}

              {this.props.prefix === 'gmina_bisztynek' && ['WypisIWyrysZMpzp'].includes(this.props.serviceInfo.eservice.shortName) ?
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict13}
                  onChange={e => this.onChange(e, 'info')}
                  onChangeSelect={e => this.onChangeSelect(e, 'info')}
                /> 
              : null}

              {['WypisIWyrysZMpzp'].includes(this.props.serviceInfo.eservice.shortName) && ['gmina_komarow_osada'].includes(this.props.prefix) ? 
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict3}
                  onChange={e => this.onChange(e, 'info')}
                />
              : null}

              {['ZaswiadczenieMPZP'].includes(this.props.serviceInfo.eservice.shortName) && ['gmina_komarow_osada'].includes(this.props.prefix) ? 
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict2}
                  onChange={e => this.onChange(e, 'info')}
                />
              : null}
              {((this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP'
                || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium'
                || this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZeStudium'
                || this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZMpzp')
                && this.props.prefix === 'gmina_domaniow') ?
                  <GrayPanel title="Cel wydania dokumentu">
                    <div className="row mobile-row">
                      <div className={leftCol} />
                      <div className={labelCol}>
                        <label htmlFor="dzialki" style={labelStyle}>
                          Cel
                        </label>
                      </div>
                      <div className={inputCol}>
                        <div><input className="form-control" type="text" onChange={(e) => this.setState({ cel: e.target.value })} /></div>
                      </div>
                      <div className={rightCol} />
                    </div>
                  </GrayPanel> : null
              }
              {(this.props.serviceInfo.eservice.signWithEPUAP || this.props.serviceInfo.eservice.confirmText) &&
                <GrayPanel title="Akceptuj">
                  {this.props.serviceInfo.eservice.signWithEPUAP &&
                    <div className={s.subtitle}>
                      <input
                        name="isDefault"
                        type="checkbox"
                        value={this.state.signDoc}
                        onChange={this.changeSignDoc}
                      /> &nbsp;&nbsp;&nbsp;
                      Podpisz dokument podpisem elektronicznym ePUAP</div>
                  }
                  {this.props.serviceInfo.eservice.confirmText &&
                    <div className={s.subtitle}>
                      <input
                        name="isDefault"
                        type="checkbox"
                        value={this.state.acceptApplication}
                        onChange={this.changeApplicationState}
                      /> &nbsp;&nbsp;&nbsp;
                      <gwiazda style={{ color: 'red' }}>*</gwiazda> {this.props.serviceInfo.eservice.confirmText}
                    </div>
                  }
                  <div className={s.subtitle} style={{ color: 'red' }}>
                    * - Pole obowiązkowe
                  </div>
                </GrayPanel>
              }
              <RodoContent prefix={this.props.prefix} />

              {this.state.eserviceDistrict && !this.state.eserviceDistrict.custom && !servicesWithoutAttachments.includes(this.props.serviceInfo.eservice.shortName) && !districtsWithoutAttachments.includes(this.props.prefix) ?
                <AttachmentsPanel
                  onChangeAttachments={this.onChangeAttachments}
                  showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}
                  draftAttachments={this.state.draftAttachments}
                />
                : null}

              <ButtonsPanel
                parentComponent={'EServices'}
                prefix={this.props.prefix}
                shortName={this.props.serviceInfo.eservice.shortName}
                serviceTitle={this.props.serviceInfo.eservice.title}
                servicesWithoutTemplates={servicesWithoutTemplates}
                showDrafts={this.state.showDrafts}
                onDraftSave={this.handleManualDraftSave}
                onSave={() => this.setState({ progress: 0, loading: this.props.serviceInfo.eservice.returnsDoc ? false : true }, () => this.validate(null, null, this.runService))}
                onCancel={history.goBack}
              />

            </div>
          </div>
          <ModalAlert
            title={this.state.errorTitle}
            bodyText={this.state.errorText}
            show={this.state.showError}
            name="errorModal"
            onHide={this.onHide}
          />
          <ModalAlert
            title={this.state.mpzpValidTitle}
            bodyText={this.state.mpzpValidText}
            show={this.state.showErrorMpzp}
            name="mpzpErrorModal"
            onHide={this.onHideMpzp}
          />
          <ModalAlert
            title={loadingTitle}
            bodyText={loadingBody}
            show={this.state.loading}
            name="loadingModal"
            onHide={this.onHide}
            disableButton
          />
        </div>
      );
    }

    return (
      <GrayPanel
        title="Trwa ładowanie zawartości..."
        bodyStyle={bodyStyle}
      >
        <img alt="Loader" src={waiting} />
      </GrayPanel>
    )
  }
}

EServices.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
};

export default withStyles(pans)(withStyles(s)(connect(mapState, mapDispatch)(EServices)));



// WEBPACK FOOTER //
// src/routes/eservices/EServices.js